module.exports = __webpack_public_path__ + "img/1516096858.17dcb059.jpg";